import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/macro'
import { InsOperation } from '@/core/models/ins-audit.model'

export const insAuditOperationMessages: Record<InsOperation, MessageDescriptor> = {
  [InsOperation.GET_INS_WITH_CARD]: msg`Get INS from Vitale card`,
  [InsOperation.GET_INS_WITHOUT_CARD]: msg`Get INS from traits`,
  [InsOperation.CHECK_INS_IDENTITY]: msg`Check INS identity`,
  [InsOperation.ACCESS_PATIENT_RECORD]: msg`Patient record access`,
  [InsOperation.UPDATE_PATIENT_IDENTITY]: msg`Identity traits update`,
  [InsOperation.RECEIVE_EXTERNAL_IDENTITY]: msg`External identity received`,
}

export const insAuditFieldMessages: Record<string, MessageDescriptor> = {
  insNIR: msg`INS identity number`,
  insOID: msg`OID`,
  identityConfirmed: msg`Identity confirmed`,
  'userInfo.surname': msg`Used surname`,
  'userInfo.name': msg`Used given name`,
  'userInfo.birthSurname': msg`Birth surname`,
  'userInfo.birthName': msg`Birth given names`,
  'userInfo.birthFirstName': msg`First birth given name`,
  'userInfo.birthday': msg`Date de naissance`,
  'userInfo.gender': msg`Gender`,
  'userInfo.birthPlaceCode': msg`Birth place code`,
  'userInfo.identityJustificationType': msg`Identity justification`,
  'userInfo.identitySupplementaryAttribute': msg`Supplementary identity attribute`,
}
